import React from "react";

const SocialAuthButton = React.forwardRef(
  ({ icon, label, onClick, disabled, ariaLabel }, ref) => (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel || label}
      className="w-full flex items-center justify-center gap-3
        bg-bg/60 hover:bg-bg/90 border border-gray-600 hover:border-gray-500
        text-white font-medium py-3.5 px-6 rounded-xl
        transition-all duration-300
        disabled:opacity-50 disabled:cursor-not-allowed"
    >
      <span className="flex-shrink-0">{icon}</span>
      <span>{label}</span>
    </button>
  )
);

SocialAuthButton.displayName = "SocialAuthButton";

export default SocialAuthButton;
